export default "__VITE_ASSET__2a0a875c__"